import React from "react";
import Section from "../ui/Section";
import { education, experience } from "../../data/profile";

function Experience() {
  return (
    <Section id="experience" eyebrow="Experience" title="Where I have worked">
      <ol className="timeline">
        {experience.map((role) => (
          <li className="timeline__item" key={`${role.organisation}-${role.role}`}>
            <div className="timeline__header">
              <h3 className="timeline__role">
                {role.role}{" "}
                <span className="timeline__org">· {role.organisation}</span>
              </h3>
              <span className="timeline__period">{role.period}</span>
            </div>
            <ul className="bullets">
              {role.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </li>
        ))}
      </ol>

      <h3 className="subsection-title">Education</h3>
      <ol className="timeline">
        {education.map((item) => (
          <li className="timeline__item" key={item.institution}>
            <div className="timeline__header">
              <h4 className="timeline__role">{item.institution}</h4>
              <span className="timeline__period">{item.period}</span>
            </div>
            <ul className="bullets">
              <li>{item.qualification}</li>
              <li>{item.result}</li>
            </ul>
          </li>
        ))}
      </ol>
    </Section>
  );
}

export default Experience;
